import { RootState } from '@store';
import { createSlice } from '@reduxjs/toolkit';

export interface LeadDetailState {
  leadDetail: any;
}

export const initialState: LeadDetailState = {
  leadDetail: {},
};

export const domainLeadDetailSlice = createSlice({
  name: 'domainLeadDetail',
  initialState,
  reducers: {
    setLeadDetailData: (state, action) => {
      state.leadDetail = action.payload;
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const { setLeadDetailData, setDefaultState } =
  domainLeadDetailSlice.actions;

export default domainLeadDetailSlice.reducer;

// selectors.
export const getLeadDetailData = (state: RootState) =>
  state.domainLeadDetail.leadDetail;
